import { styled, selectTheme, Box, Typography } from '@creditas-ui/react';


export const ProgressContainer = styled.div`
  margin: auto;
  height: 100%;
  width: fit-content;
  span {
    top: 50%;
  }
`;

export const MiniCardContainer = styled(Box)`
  box-shadow: ${selectTheme('shadow.xs')};
  border-radius: 16px;
  min-width: 319px;
  width: 100%;
  margin-top: 32px;
  padding: 8px 16px 8px 8px;
  @media (min-width: ${selectTheme('breakpoints.4xl')}) {
    padding: 8px 24px 8px 8px;
  }
`;

export const MiniImage = styled.img`
  border-radius: 8px;
  width: 65px;
  height: 65px;
  object-fit: cover;
`;

export const ResponsiveLabel = styled(Typography)`
  font-size: 14px;
  @media (min-width: ${selectTheme('breakpoints.6xl')}) {
    font-size: 16px;
  }
`;
